import type { TermsStatus } from '../types';
import { USER_ROLES } from './constants';
import { isGuestOnlyRoute } from './routes';

export const TERMS_AND_CONDITIONS_DOCUMENT_URL = 'https://nativeteams.com/terms/remoter';

export const TERMS_ACCEPTANCE_PATH = '/terms-acceptance';

export const TERMS_ACCEPTANCE_SOURCE = {
  WEB: 'web',
  MOBILE: 'mobile',
} as const;

export function isTermsAcceptancePath(pathname: string): boolean {
  return isGuestOnlyRoute([TERMS_ACCEPTANCE_PATH], pathname);
}

export function getAuthTermsAcceptanceUrl(authBaseUrl: string, search = ''): string {
  const url = new URL(TERMS_ACCEPTANCE_PATH, authBaseUrl);
  url.search = search;
  return url.toString();
}

export const TERMS_ACCEPTANCE_COPY = {
  title: 'Terms & conditions',
  description:
    'Before you continue, please review the terms covering your service balance, security reserve, platform fees, and refunds.',
  documentLabel: 'Terms and conditions',
  checkboxLabel: 'I have read and agree to the terms & conditions.',
  button: 'Agree and continue',
  buttonLoading: 'Agreeing',
  logout: 'Log out',
  logoutLoading: 'Logging out',
  acceptError: 'Failed to accept terms & conditions',
  logoutError: 'Failed to logout, please try again later',
  loadError: 'Failed to load terms & conditions',
  loadErrorTitle: "Couldn't load terms & conditions",
  loadErrorDescription:
    'We could not confirm whether you need to accept the latest terms. Please try again.',
  retry: 'Try again',
  retryLoading: 'Loading',
} as const;

export function hasValidTermsStatus(terms?: TermsStatus | null): terms is TermsStatus {
  return typeof terms?.requires_action === 'boolean';
}

export function hasB2CTermsRole(roles?: string[]): boolean {
  return (
    (roles ?? []).includes(USER_ROLES.B2C_STANDARD) ||
    (roles ?? []).includes(USER_ROLES.B2C_FREE) ||
    (roles ?? []).includes(USER_ROLES.B2C_EMPLOYEE)
  );
}
